/** Validate form **/
const _ = require('lodash');

// Own e-mail validation (via CheckEmail() in PHP)
$.validator.addMethod('customemail',
    _.debounce(
        function (value, element) {
            return eval($.ajax({
                url: strPath + 'components/check-email.php',
                type: 'POST',
                async: false,
                data: {txtEmail: value},
            }).responseText);
        }, 700, {'leading': true}), true
);

// Own number validation (allows ',')
jQuery.validator.addMethod('mynumber', function (value, element) {
    return this.optional(element) || /^(\d+|\d+(,|.)\d{1,2})$/.test(value);
}, 'Please specify the correct number format');

// Unsubscribe
function FormValidateUnsubscribe(objForm) {
    var validator = $(objForm).validate(
        {
            rules: {
                // Check if e-mail exists in database
                txtEmail: {
                    remote: {
                        url: strAjaxPath + 'validate/unsubscribe.php',
                        type: 'post',
                    },
                },
            },
            messages: {
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid,
                },
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
        });

    return validator;
}

// Login
function FormValidateLogin(objForm, strTypeLogin) {
    var validator = $(objForm).validate(
        {
            messages: {
                txtUsername: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid,
                },
                txtPassword: {
                    required: strLabelGivePassword,
                },
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            submitHandler: function () {
                // Check if combination username and password exists (don't check in validator, problem with errors)
                $.post(strAjaxPath + 'validate/login.php', {txtUsername: $('input#txtUsername').val(), txtPassword: $('input#txtPassword').val(), chkKeepLoggedIn: $('input#chkKeepLoggedIn').is(':checked')}, function (strData) {
                    // Remove previous errors
                    $('input#txtUsername').removeClass('is-invalid');
                    $('input#txtPassword').removeClass('is-invalid');
                    $('input#txtPassword').parent().find('label.invalid-feedback').remove();

                    if (strData !== true) {
                        // Show error
                        $('input#txtUsername').addClass('is-invalid');
                        $('input#txtPassword').addClass('is-invalid');
                        $('input#txtPassword').after($('<label id="txtPassword" class="d-flex invalid-feedback" for="txtPassword">' + strData + '</label>'));
                    } else {
                        if (strTypeLogin == 'loginpopup') {
                            // Login (in popup) after adding giftcard code
                            $.post(strAjaxPath + 'validate/giftcard-after-login.php', '', function (strData) {
                                parent.location.reload();
                            });
                        } else {
                            // Correct => submit form
                            objForm.unbind('submit');
                            objForm.submit();
                        }
                    }
                }, 'json');
            },
        });

    return validator;
}

// Forgot password
function FormValidateForgotPassword(objForm) {
    var validator = $(objForm).validate(
        {
            rules: {
                // Check if e-mail exists and has a password
                txtEmail: {
                    remote: {
                        url: strAjaxPath + 'validate/forgot-password.php',
                        type: 'post',
                    },
                },
            },
            // Error has to be shown after the button
            errorPlacement: function (error, element) {
                $('#txtEmail-error').remove();
                if (element.attr('name') == 'txtEmail') {
                    error.insertAfter('#frmForgotPassword');
                } else {
                    error.insertAfter(element);
                }
            },
            messages: {
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid,
                },
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
        });

    return validator;
}


// Forgot password reset
function FormValidateForgotPasswordReset(objForm) {
    var validator = $(objForm).validate(
        {
            rules: {
                // Check if password is valid
                txtPassword: {
                    remote: {
                        url: strAjaxPath + 'validate/forgot-password-reset.php',
                        type: 'post',
                    },
                },
                txtPasswordConfirm: {
                    equalTo: '#txtPassword',
                },
            },
            messages: {
                txtPassword: {
                    required: strLabelGivePassword,
                },
                txtPasswordConfirm: {
                    required: strLabelConfirmPassword,
                    equalTo: strLabelPasswordsDontMatch,
                },
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
        });

    return validator;
}


// Register
function FormValidateRegister(objForm) {
    var validator = $(objForm).validate(
        {
            // Don't ignore hidden fields (for hidden checkboxes)
            ignore: [],
            rules: {
                // Check if e-mail doesn't exists (with a username)
                txtEmail: {
                    remote: {
                        url: strAjaxPath + 'validate/register-email.php',
                        type: 'post',
                    },
                },
                // Check if password is valid
                txtPassword: {
                    remote: {
                        url: strAjaxPath + 'validate/register-password.php',
                        type: 'post',
                    },
                },
                txtPasswordConfirm: {
                    equalTo: '#txtPassword',
                },
                // Check if vat number is valid
                /* txtVatnr: {
                     remote: {
                         url: strAjaxPath + 'validate/register-vat.php',
                         type: 'post',
                         data: {
                             txtVatpr: function () {
                                 return $('#txtVatpr').val();
                             },
                         },
                     },
                 },*/
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            // Error zipcode has to be shown after field 'city'
            errorPlacement: function (error, element) {
                if (element.attr('name') == 'chkConditions') {
                    error.insertAfter('label[for="chkConditions"]');
                } else if (element.attr('name') == 'chkNewsletter') {
                    error.insertAfter('label[for="chkNewsletter"]');
                } /*else if (element.attr('name') == 'optMembership') {
                    error.insertAfter('div.membership-register');
                } */ else if (element.attr('name') == 'txtDateOfBirth') {
                    error.appendTo(element.closest('div'));
                } else {
                    error.insertAfter(element);
                }
            },
            messages: {
                txtCompanyname: {
                    required: strLabelGiveCompanyname,
                },
                txtVatpr: {
                    required: strLabelGiveVatPr,
                },
                txtVatnr: {
                    required: strLabelGiveVatNr,
                },
                txtFirstname: {
                    required: strLabelGiveFirstname,
                },
                txtLastname: {
                    required: strLabelGiveLastname,
                },
                txtStreet: {
                    required: strLabelGiveStreet,
                },
                txtAddressNumber: {
                    required: strLabelGiveAddressNumber,
                },
                txtZipcode: {
                    required: strLabelGiveZipcode,
                },
                txtCity: {
                    required: strLabelGiveCity,
                },
                txtPhone: {
                    required: strLabelGivePhoneMobile,
                },
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid,
                },
                txtUserName: {
                    required: strLabelGiveUsername,
                },
                txtPassword: {
                    required: strLabelGivePassword,
                },
                txtPasswordConfirm: {
                    required: strLabelConfirmPassword,
                    equalTo: strLabelPasswordsDontMatch,
                },
                /*optMembership: {
                    required: strLabelGiveMembership,
                },*/
                txtDateOfBirth: {
                    required: strLabelGiveDateOfBirth,
                },
            },
        });

    return validator;
}

// Edit address account data
function FormValidateAddressAccount(objForm) {
    var validator = $(objForm).validate(
        {
            rules: {
                // Check if e-mail doesn't already exists for another address
                txtEmail: {
                    remote: {
                        url: strAjaxPath + 'validate/address-email.php',
                        type: 'post',
                    },
                },
                // Check if the password is valid
                txtPassword: {
                    remote: {
                        url: strAjaxPath + 'validate/register-password.php',
                        type: 'post',
                    },
                },
                txtPasswordConfirm: {
                    equalTo: '#txtPassword',
                },
            },
            messages: {
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid,
                },
                txtPasswordConfirm: {
                    equalTo: strLabelPasswordsDontMatch,
                },
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
        });

    return validator;
}


// Edit address data
function FormValidateAddressData(objForm) {
    var validator = $(objForm).validate(
        {
            /*rules: {
                // Check if vat number is valid
                txtVatnr: {
                    remote: {
                        url: strAjaxPath + 'validate/register-vat.php',
                        type: 'post',
                        data: {
                            txtVatpr: function () {
                                return $('#txtVatpr').val();
                            },
                        },
                    },
                },
            },*/
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            // Error zipcode has to be shown after field 'city'
            errorPlacement: function (error, element) {
                if (element.attr('name') == 'txtZipcode') {
                    error.insertAfter('#txtCity');
                } else if (element.attr('name') == 'txtStreet') {
                    error.insertAfter('#txtAddressNumber');
                } else if (element.attr('name') == 'txtDateOfBirth') {
                    error.appendTo(element.closest('div'));
                } else {
                    error.insertAfter(element);
                }
            },
            messages: {
                txtFirstname: {
                    required: strLabelGiveFirstname,
                },
                txtLastname: {
                    required: strLabelGiveLastname,
                },
                txtStreet: {
                    required: strLabelGiveStreet,
                },
                txtAddressNumber: {
                    required: strLabelGiveAddressNumber,
                },
                txtZipcode: {
                    required: strLabelGiveZipcode,
                },
                txtCity: {
                    required: strLabelGiveCity,
                },
                txtPhone: {
                    required: strLabelGivePhoneMobile,
                },
                txtDateOfBirth: {
                    required: strLabelGiveDateOfBirth,
                },
            },
        });

    return validator;
}


// Edit address data
function FormValidateNewProductOrder(objForm) {
    var validator = $(objForm).validate(
        {
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            // Error zipcode has to be shown after field 'city'
            errorPlacement: function (error, element) {
                /* if (element.attr('name') == 'txtZipcode') {
                     error.insertAfter('#txtCity');
                 } else if (element.attr('name') == 'txtStreet') {
                     error.insertAfter('#txtAddressNumber');
                 } else if (element.attr('name') == 'txtDateOfBirth') {
                     error.appendTo(element.closest('div'));
                 } else {
                     error.insertAfter(element);
                 }*/
            },
            messages: {
                txtCode: {
                    required: strLabelGiveCode,
                },
                txtTitle: {
                    required: strLabelGiveTitle,
                },
                txtTitleAdd: {
                    required: strLabelGiveTitle,
                },
                txtPage: {
                    required: strLabelGivePage,
                },
                txtEditor: {
                    required: strLabelGiveEditor,
                },
                txtQuantity: {
                    required: strLabelGiveQuantity,
                },
            },
        });

    return validator;
}


// Add address to address book
function FormValidateAddAddress(objForm) {
    var validator = $(objForm).validate(
        {
            messages: {
                txtFirstname: {
                    required: strLabelGiveFirstname,
                },
                txtLastname: {
                    required: strLabelGiveLastname,
                },
                txtStreet: {
                    required: strLabelGiveStreet,
                },
                txtAddressNumber: {
                    required: strLabelGiveAddressNumber,
                },
                txtZipcode: {
                    required: strLabelGiveZipcode,
                },
                txtCity: {
                    required: strLabelGiveCity,
                },
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
        });

    return validator;
}

// Edit address from address book
function FormValidateUpdateAddress(objForm) {
    var validator = $(objForm).validate(
        {
            messages: {
                txtFirstname: {
                    required: strLabelGiveFirstname,
                },
                txtLastname: {
                    required: strLabelGiveLastname,
                },
                txtStreet: {
                    required: strLabelGiveStreet,
                },
                txtAddressNumber: {
                    required: strLabelGiveAddressNumber,
                },
                txtZipcode: {
                    required: strLabelGiveZipcode,
                },
                txtCity: {
                    required: strLabelGiveCity,
                },
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
        });

    return validator;
}

// Cart logged in
function FormValidateCartLoggedIn(objForm) {

    var validator = $(objForm).validate(
        {
            // Ignore has to be here, because then it shows also error messages if the form isn't visible
            ignore: [],
            // Error zipcode must be shown after field 'city'
            errorPlacement: function (error, element) {
                if (element.attr('name') == 'txtZipcode') {
                    error.insertAfter('#txtCity');
                } else if (element.attr('name') == 'txtStreet') {
                    error.insertAfter('#txtAddressNumber');
                } else if (element.attr('name') == 'txtDateOfBirth') {
                    error.appendTo(element.closest('div'));
                } else {
                    error.insertAfter(element);
                }
            },
            invalidHandler: function (event, validator) {
                // In step billing data in cart => show input fields (if needed)
                $('a#billing-modify').click();
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            messages: {
                txtFirstname: {
                    required: strLabelGiveFirstname,
                },
                txtLastname: {
                    required: strLabelGiveLastname,
                },
                txtStreet: {
                    required: strLabelGiveStreet,
                },
                txtAddressNumber: {
                    required: strLabelGiveAddressNumber,
                },
                txtZipcode: {
                    required: strLabelGiveZipcode,
                },
                txtCity: {
                    required: strLabelGiveCity,
                },
                txtPhone: {
                    required: strLabelGivePhoneMobile,
                },
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid,
                },
                txtDateOfBirth: {
                    required: strLabelGiveDateOfBirth,
                },
            },
        });

    return validator;
}

// Cart delivery - transport input (alternative delivery address)
function FormValidateCartTransportInput(objForm) {
    let validator  = null;
    if($("txtTransportCompanyname").val() != "" && $("#txtTransportFirstname").val() == "" && $("#txtTransportLastname").val() == "") {
        validator = $(objForm).validate({
                // Error zipcode must be shown after field 'city'
                errorPlacement: function (error, element) {
                    if (element.attr('name') == 'txtTransportZipcode') {
                        error.insertAfter('#txtTransportCity');
                    } else {
                        error.insertAfter(element);
                    }
                },
                errorClass: 'd-flex invalid-feedback',
                errorElementClass: 'is-invalid',
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                messages: {
                    txtTransportAddress: {
                        required: strLabelGiveAddress,
                    },
                    txtTransportZipcode: {
                        required: strLabelGiveZipcode,
                    },
                    txtTransportCity: {
                        required: strLabelGiveCity,
                    },
                },
            });
    } else {
        validator = $(objForm).validate({
                // Error zipcode must be shown after field 'city'
                errorPlacement: function (error, element) {
                    if (element.attr('name') == 'txtTransportZipcode') {
                        error.insertAfter('#txtTransportCity');
                    } else {
                        error.insertAfter(element);
                    }
                },
                errorClass: 'd-flex invalid-feedback',
                errorElementClass: 'is-invalid',
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                messages: {
                    txtTransportFirstname: {
                        required: strLabelGiveFirstname,
                    },
                    txtTransportLastname: {
                        required: strLabelGiveLastname,
                    },
                    txtTransportAddress: {
                        required: strLabelGiveAddress,
                    },
                    txtTransportZipcode: {
                        required: strLabelGiveZipcode,
                    },
                    txtTransportCity: {
                        required: strLabelGiveCity,
                    },
                },
            });
    }
    return validator;
}

// Gift card
function FormValidateGiftCard(objForm) {
    var validator = $(objForm).validate(
        {
            messages: {
                txtMessage: {
                    required: strLabelGiveMessage,
                },
                txtName: {
                    required: strLabelGiveName,
                },
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid,
                },
                txtReceiverName: {
                    required: strLabelGiveNameReceiver,
                },
                txtReceiverEmail: {
                    required: strLabelGiveEmailReceiver,
                    customemail: strLabelEmailReceiverInvalid,
                },
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            submitHandler: function () {

                // Make a string from all input fields and make them begin with str, int
                var strGetParams = objForm.serialize();
                var strParams = strGetParams.replace(/&txt/g, '&str');
                strParams = strParams.replace('&hdnFormType', '&strFormType');
                strParams = strParams.replace(/&hdn/g, '&int');
                strParams = strParams.replace(/&opt/g, '&str');

                // Add giftcard to cart after the form is validated
                AddProductToCart(objForm, $('#btnAddToCart'), false, false, true, strParams);
            },
        });

    return validator;
}

// Add a new wishlist
function FormValidateAddWishlist(objForm) {
    var validator = $(objForm).validate({
        ignore: [],
        errorPlacement: function (error, element) {
            if (element.attr('name') == 'txtTitle') {
                error.insertAfter('#frmWishlist');
            } else if (element.is('input[type="hidden"]')) {
                error.appendTo(element.closest('li'));
            } else {
                error.insertAfter(element);
            }
        },
        messages: {
            txtTitle: {
                required: strLabelGiveTitle,
            },
        },
        errorClass: 'd-flex invalid-feedback',
        errorElementClass: 'is-invalid',
        highlight: function (element, errorClass, validClass) {
            $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
        },
        submitHandler: function () {
            $.post(strAjaxPath + 'wishlist/wishlist-add-list.php', objForm.serialize(), function (data) {
                if (data == 'OK') {
                    window.location.reload();
                }
            });
        },
    });
    return validator;
}

//-- Add review
function FormValidateReview(objForm) {
    var validator = $(objForm).validate(
        {
            //-- Ignore: hidden fields must be validated
            ignore: '',
            messages: {
                txtFirstname: {
                    required: strLabelGiveFirstname,
                },
                txtLastname: {
                    required: strLabelGiveLastname,
                },
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid,
                },
                hdnCommentRating: {
                    required: strLabelGiveReview,
                },
            },
        });
    return validator;
}

// Pour qui? biography (customerzone)
function FormValidatePourQuiBiography(objForm) {
    var validator = $(objForm).validate(
        {
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            messages: {
                txtNameCartoonist: {
                    required: strLabelGiveNameCartoonist,
                },
            },
        });

    return validator;
}

// Pour qui? add own product (customerzone)
function FormValidateOwnProduct(objForm) {
    var validator = $(objForm).validate(
        {
            //-- Ignore: hidden fields must be validated
            //ignore: '',
            rules: {
                txtPrice: {
                    required: true,
                    mynumber: true,
                },
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            messages: {
                txtProductName: {
                    required: strLabelGiveProductName,
                },
                txtDescription: {
                    required: strLabelGiveDescription,
                },
                txtPrice: {
                    required: strLabelGivePrice,
                    mynumber: strLabelPriceInvalid,
                },
            },
        });
    return validator;
}

// CUSTOM: become member (not VIP) (customerzone)
function FormValidateBecomeMember(objForm) {
    var validator = $(objForm).validate(
        {
            //-- Ignore: hidden fields must be validated
            //ignore: '',
            /*rules: {
                txtPrice: {
                    required: true,
                    mynumber: true,
                },
            },*/
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            errorPlacement: function (error, element) {
                if (element.attr('name') == 'txtDateOfBirth') {
                    error.appendTo(element.closest('div'));
                } else if (element.attr('name') == 'chkNewsletter') {
                    error.appendTo(element.closest('div'));
                } else {
                    error.insertAfter(element);
                }
            },
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            messages: {
                txtDateOfBirth: {
                    required: strLabelGiveDateOfBirth,
                },
                chkNewsletter: {
                    required: strLabelReceiveNewsletterError,
                },
            },
        });
    return validator;
}

// Share wishlist
function FormValidateShareWishlist(objForm) {
    var validator = $(objForm).validate(
        {
            messages: {
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid,
                },
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
        });

    return validator;
}

// Add subscription
function FormValidateAddSubscription(objForm) {
    var validator = $(objForm).validate(
        {
            // Don't ignore hidden fields (for hidden checkboxes)
            ignore: [],
            rules: {
                intQuantity: {
                    required: true,
                    mynumber: true
                },
            },
            errorClass: 'd-flex invalid-feedback',
            errorElementClass: 'is-invalid',
            errorPlacement: function (error, element) {
                if (element.attr('name') == 'serieno') {
                    error.insertAfter('#txtSeries');
                } else {
                    error.insertAfter(element);
                }
            },
            highlight: function (element, errorClass, validClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            messages: {
                txtSeries: {
                    required: '',
                },
                serieno: {
                    required: strLabelGiveSeries,
                },
                intQuantity: {
                    required: strLabelGiveQuantity,
                    mynumber: strLabelGiveQuantity
                },
            },
        });
    return validator;
}

window.FormValidateAddWishlist = FormValidateAddWishlist;
window.FormValidateGiftCard = FormValidateGiftCard;
window.FormValidateCartTransportInput = FormValidateCartTransportInput;
window.FormValidateCartLoggedIn = FormValidateCartLoggedIn;
window.FormValidateUpdateAddress = FormValidateUpdateAddress;
window.FormValidateAddAddress = FormValidateAddAddress;
window.FormValidateAddressData = FormValidateAddressData;
window.FormValidateAddressAccount = FormValidateAddressAccount;
window.FormValidateRegister = FormValidateRegister;
window.FormValidateForgotPasswordReset = FormValidateForgotPasswordReset;
window.FormValidateForgotPassword = FormValidateForgotPassword;
window.FormValidateLogin = FormValidateLogin;
window.FormValidateUnsubscribe = FormValidateUnsubscribe;
window.FormValidateReview = FormValidateReview;
window.FormValidatePourQuiBiography = FormValidatePourQuiBiography;
window.FormValidateOwnProduct = FormValidateOwnProduct;
window.FormValidateBecomeMember = FormValidateBecomeMember;
window.FormValidateNewProductOrder = FormValidateNewProductOrder;
window.FormValidateShareWishlist = FormValidateShareWishlist;
window.FormValidateAddSubscription = FormValidateAddSubscription;
